import {core} from './core';
core();
//functionality for unicef walk and päivätyökeräys

import sponsorView from './modules/walk/sponsor-view';
import materialsView from './modules/walk/materials-view';



const schoolPickerContainer = document.querySelector('.js-walk-school-picker');
if (schoolPickerContainer) {
  import('./modules/walk/school-picker')
    .then(({default: schoolPicker}) => schoolPicker.init(schoolPickerContainer))
}

const walkRegistrationContainer = document.querySelector('.js-walk-registration');
if (walkRegistrationContainer) {
  import('./modules/walk/registration-view')
    .then(({default: registrationView}) => registrationView.init(walkRegistrationContainer))
}

sponsorView.init();
materialsView.init();
